import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { withRouter } from 'react-router';

import { useQuery, gql } from '@nerdwallet/apollo';
import JobPage from '../components/company/job-page';
import NotFound from '../components/company/not-found';
import { logGqlError } from '~/client/lib/logger-utils';

const jobDataQuery = gql`
  query GreehhouseJob($id: ID!) {
    greenhouseJob(id: $id) {
      id
      title
      location
      content
      department {
        id
        name
      }
    }
  }
`;

const JobRoute = ({ match }) => {
  const { data, loading, error } = useQuery(jobDataQuery, {
    variables: {
      id: match?.params?.id,
    },
  });

  if (loading) return null;

  if (error || !data?.greenhouseJob?.title) {
    if (error) {
      logGqlError(error);
    }
    return <NotFound errorType="job" />;
  }

  return (
    <React.Fragment>
      <DocumentTitle title={`${data.greenhouseJob.title} | NerdWallet`} />
      <JobPage job={data.greenhouseJob} />
    </React.Fragment>
  );
};

JobRoute.displayName = 'Job Route';
JobRoute.analyticsName = 'job_page';
JobRoute.segmentPageName = 'job_page';

JobRoute.propTypes = {
  match: PropTypes.object,
};

export default withRouter(JobRoute);
